import { createSelector } from '@ngrx/store';
import { getSubstanceId } from 'app/modules/dossier-area/pages/dossier/store/dossier.selectors';
import { IAppState } from 'app/modules/shared-area/root-state';
import { ISachverhaltState } from './sachverhalt.state';

export const sachverhaltState = (state: IAppState): ISachverhaltState => state.shared.sachverhalt;

export const getSachverhaltEditValues = createSelector(sachverhaltState, getSubstanceId, (state, id) => ({
  ...state.sachverhaltEdit,
  id,
}));

export const getSachverhalt = createSelector(sachverhaltState, state => state.sachverhalt);
export const isSachverhaltLoading = createSelector(sachverhaltState, state => state.isSachverhaltLoading);
export const serverValidationErrors = createSelector(sachverhaltState, state => state.serverValidationErrors);
export const getTriggerElement = createSelector(sachverhaltState, state => state.triggerElement);
